const Circle1Active = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} fill="none">
    <rect width={30.855} height={30.855} x={0.573} y={0.573} rx={15.428} />
    <rect
      width={30.855}
      height={30.855}
      x={0.573}
      y={0.573}
      className="stroke-stepper-active-border"
      strokeWidth={1.145}
      rx={15.428}
    />
    <path
      className="fill-stepper-active-text-color"
      d="M16.983 10.992V21H15.72v-8.429l-2.55.93v-1.142l3.616-1.367h.198Z"
    />
  </svg>
)
export { Circle1Active }
